export enum TemplateTypeEnum {
  DURABLE = 'durable',
  PERISHABLE = 'perishable',
  THREE_P_DURABLE = '3p_durable',
}

export const TemplateTypeOptions = [
  { value: TemplateTypeEnum.DURABLE, label: 'Durable goods' },
  { value: TemplateTypeEnum.PERISHABLE, label: 'Perishable goods' },
];

export const TemplateTypeOptions3P = [
  { value: TemplateTypeEnum.THREE_P_DURABLE, label: 'Durable goods' },
];
